import qs from 'qs'
import AbstractApi from '@/api/abstract'
import { apiInterface } from '@/api/interfaces'
import { userApiReq, userApiRes } from './interfaces'

class UserApi implements apiInterface.IUserApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  getUsers = async (params: userApiReq.IGetUsersReq = {}): Promise<userApiRes.IGetUsersRes> => {
    const res = await this.ctx.get<userApiReq.IGetUsersReq, userApiRes.IGetUsersRes>(
      '/user/',
      params,
      {
        paramsSerializer: (params: userApiReq.IGetUsersReq) =>
          qs.stringify(params, { arrayFormat: 'repeat' })
      }
    )
    return res.data
  }

  getUser = async (id: number): Promise<userApiRes.IGetUserRes> => {
    const res = await this.ctx.get<unknown, userApiRes.IGetUserRes>(`/user/${id}/`)
    return res.data
  }

  updateUser = async (
    id: number,
    params: userApiReq.IUpdateUserReq = {}
  ): Promise<userApiRes.IGetUserRes> => {
    const res = await this.ctx.patch<userApiReq.IUpdateUserReq, userApiRes.IGetUserRes>(
      `/user/${id}/`,
      params
    )
    return res.data
  }

  responseUserEmail = async (id: number, params: userApiReq.IResponseUserEmailReq = {}) => {
    const res = await this.ctx.post<
      userApiReq.IResponseUserEmailReq,
      userApiRes.IResponseUserEmailRes
    >(`/user/${id}/send_email/`, params)
    return res.data
  }

  responseUserSms = async (id: number, params: userApiReq.IResponseUserSmsReq = {}) => {
    const res = await this.ctx.post<userApiReq.IResponseUserSmsReq, userApiRes.IResponseUserSmsRes>(
      `/user/${id}/send_sms/`,
      params
    )
    return res.data
  }

  getCertificatesUser = async (
    params: userApiReq.IGetCertificatesUserReq = {}
  ): Promise<userApiRes.IGetCertificatesUserRes> => {
    const res = await this.ctx.get<
      userApiReq.IGetCertificatesUserReq,
      userApiRes.IGetCertificatesUserRes
    >('/user/certificate_user', params, {
      paramsSerializer: (params: userApiReq.IGetCertificatesUserReq) =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    })
    return res.data
  }

  createUser = async (params: userApiReq.ICreateUserReq): Promise<userApiRes.ICreateUserRes> => {
    const res = await this.ctx.post<userApiReq.ICreateUserReq, userApiRes.ICreateUserRes>(
      '/user/create_by_staff/',
      params
    )
    return res.data
  }

  getCurrentUser = async (): Promise<userApiRes.IGetCurrentUserRes> => {
    const res = await this.ctx.get<unknown, userApiRes.IGetCurrentUserRes>('/user/current_user/')
    return res.data
  }

  getDepositListUser = async (
    params: userApiReq.IGetDepositListUserReq = {}
  ): Promise<userApiRes.IGetDepositListUserRes> => {
    const res = await this.ctx.get<
      userApiReq.IGetDepositListUserReq,
      userApiRes.IGetDepositListUserRes
    >('/user/deposit_list', params, {
      paramsSerializer: (params: userApiReq.IGetDepositListUserReq) =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    })
    return res.data
  }

  getContracts = async (
    params: userApiReq.IGetContractsReq = {}
  ): Promise<userApiRes.IGetContractsRes> => {
    const res = await this.ctx.get<userApiReq.IGetContractsReq, userApiRes.IGetContractsRes>(
      '/user/get_contracts/',
      params,
      {
        paramsSerializer: (params: userApiReq.IGetContractsReq) =>
          qs.stringify(params, { arrayFormat: 'repeat' })
      }
    )
    return res.data
  }

  getGroups = async (): Promise<userApiRes.IGetGroupsRes[]> => {
    const res = await this.ctx.get<unknown, userApiRes.IGetGroupsRes[]>('/user/group/groups/')
    return res.data
  }

  changePhoneCall = async (
    id: number,
    params: userApiReq.IChangePhoneCallReq
  ): Promise<userApiRes.IChangePhoneCallRes> => {
    const res = await this.ctx.patch<
      userApiReq.IChangePhoneCallReq,
      userApiRes.IChangePhoneCallRes
    >(`/user/phone_call/${id}/`, params)
    return res.data
  }

  getUserTypes = async (
    params: userApiReq.IGetUserTypesReq = {}
  ): Promise<userApiRes.IGetUserTypesRes> => {
    const res = await this.ctx.get<unknown, userApiRes.IGetUserTypesRes>(
      '/user/user_types/',
      params
    )
    return res.data
  }

  getSourceInfoTraffic = async (id: number): Promise<userApiRes.IGetSourceInfoTrafficRes> => {
    const res = await this.ctx.get<unknown, userApiRes.IGetSourceInfoTrafficRes>(
      `/user/source_of_traffic/${id}`
    )
    return res.data
  }

  getSourceTraffic = async (
    params: userApiReq.IGetSourceTrafficReq = {}
  ): Promise<userApiRes.IGetSourceTrafficRes> => {
    const res = await this.ctx.get<
      userApiReq.IGetSourceTrafficReq,
      userApiRes.IGetSourceTrafficRes
    >('/user/source_of_traffic/', params)
    return res.data
  }
}

export default UserApi
